import { Component, HostListener, Input } from '@angular/core';
import { OrderListWrapperComponent } from '../../../../pages/invoice/printable/compact/order-list-wrapper/order-list-wrapper.component';
import { MatDialog } from '@angular/material/dialog';
import { PosDetailWithOrders } from '../../../../../../core/models/pos.model';

@Component({
  selector: 'pos-order-mobile',
  templateUrl: './pos-order-mobile.component.html',
  styleUrls: ['./pos-order-mobile.component.scss']
})
export class PosOrderMobileComponent {
  @HostListener('window:resize', ['$event'])
  onWindowResize(): void {
    this.updateMobileResolution();
  }

  @Input() pos: PosDetailWithOrders;

  public isMobileResolution: boolean;

  /**
   * Constructor
   */
  constructor(private _matDialog: MatDialog) {
    this.isMobileResolution = window.innerWidth < 720;
  }

  private updateMobileResolution(): void {
    this.isMobileResolution = window.innerWidth < 720;
  }

  showOrder(): void {
    const dialogRef = this._matDialog.open(OrderListWrapperComponent, {
      height: '100vh',
      width: '100vw',
      panelClass: 'receiptOnModal',
      autoFocus: false,
      data: {
        pos: this.pos,
        orders: this.pos?.orders,
        isViewOnly: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Order view closed');
    });
  }
}
